import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { MapPin, Home, Star, Award, Users, Calendar } from 'lucide-react';

const ProjectHighlights = () => {
  const highlights = [
    {
      icon: <Home className="w-8 h-8 text-amber-400" />,
      title: "Premium Residences",
      description: "Spacious 2, 2.5 & 3 BHK luxury apartments with elegant design and superior specifications.",
      badge: "Starting ₹85 Lakhs"
    },
    {
      icon: <Calendar className="w-8 h-8 text-amber-400" />,
      title: "Early-Bird Advantage", 
      description: "Just launched — book now and customize your own specifications.",
      badge: "CUSTOMIZE",
      isSpecial: true,
      promoText: "Unlock Your Exclusive Launch Offer!"
    },
    {
      icon: <MapPin className="w-8 h-8 text-amber-400" />,
      title: "Prime Location",
      description: "Excellent connectivity with metro access, leading schools, hospitals, and CBD just minutes away.",
      badge: "5 mins to Metro"
    },
    {
      icon: <Award className="w-8 h-8 text-amber-400" />,
      title: "Vaasthu-Compliant",
      description: "All apartments are 100% Vaasthucompliant with East-facing layouts, ensuring harmony and positive energy.",
      badge: "EAST FACING"
    },
    {
      icon: <Users className="w-8 h-8 text-amber-400" />,
      title: "Proven Track Record",
      description: "A trusted developer with 8+ years of expertise and 2,00,000+ sq.ft successfully delivered.",
      badge: "8 + YEARS"
    },
    {
      icon: <Star className="w-8 h-8 text-amber-400" />,
      title: "Smart Essentials",
        description: "Power Backup, CCTV Surveillance, EV Charging Points, and Oversized Car Parking for convenience & security.",
      badge: "AMENITIES"
    }
  ];

    return (
  <section id="highlights" className="py-20 pb-24 bg-gradient-to-br from-teal-100 via-teal-50 to-white mb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <Badge variant="secondary" className="mb-4 bg-amber-100 text-teal-700">
            Project Highlights
          </Badge>
          <h2 className="text-4xl font-bold text-gray-900 mb-4 font-['Squada_One']">
            Why Choose <span className="text-teal-700">Blucon Sunrise</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Blucon Sunrise offers more UDS, top-notch specs, and
            Best-in-class amenities — all in a prime Chennai location.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {highlights.map((highlight, index) => (
            <Card 
              key={index} 
              className={`group hover:shadow-xl hover:shadow-emerald-200/50 transition-all duration-300 hover:border-2 hover:border-amber-400 ${
                index === 1 
                  ? 'bg-yellow-100/90 backdrop-blur-sm border-2 border-amber-300 animate-pulse' 
                  : 'border-0 bg-gray-50/80 backdrop-blur-sm'
              }`}
            >
              <CardContent className="p-8 relative">
                <div className="flex items-start justify-between mb-6">
                  <div className="p-3 bg-[#0c2125] rounded-2xl group-hover:bg-[#0c2125]/80 transition-colors">
                    {highlight.icon}
                  </div>
                  <Badge className="bg-yellow-100 text-green-700 border-0 text-[12px] font-bold">
                    {highlight.badge}
                  </Badge>
                </div>
                
                <h3 className="text-xl font-semibold text-gray-900 mb-3 text-[20px]">
                  {highlight.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed text-[16px]">
                  {highlight.description}
                </p>
                
                {index === 1 && highlight.promoText && (
                  <div className="mt-4 bg-gradient-to-r from-orange-400 to-orange-500 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-md text-center">
                    {highlight.promoText}
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="flex items-center justify-center space-x-2 bg-white rounded-full px-16 py-4 shadow-lg shadow-purple-100/50 w-full max-w-md mx-auto border border-gray-200">
            <span className="text-gray-600 text-[24px]">Over</span>
            <span className="text-3xl font-bold text-green-700">200+</span>
            <span className="text-gray-600 text-[20px]">Happy Families</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectHighlights;